<div class="lang-switcher-backoffice">
  GER <mat-slide-toggle [(ngModel)]="lang" (change)="changeLang($event)">EN</mat-slide-toggle>
</div>
